<template>
    <div id="quantity_flex">
        <button class="btn-quantity" @click="decreaseValue()">
            <img v-if="this.itemQuantity <= 1" src="@/assets/icon/ic_minus_inactive.svg" alt="">
            <img v-else src="@/assets/icon/ic_minus_active.png" alt="">
        </button>
        <div class="quantity-txt">{{itemQuantity}}</div>
        <button class="btn-quantity" @click="increaseValue()">
            <img v-if="isLimit || !isCanDraw" src="@/assets/icon/ic_plus_inactive.png" alt="">
            <img v-else src="@/assets/icon/ic_plus_active.svg" alt="">
        </button>
    </div>
</template>

<script>
export default {
    name: 'QuantityButton',
    props: {
        value: { type: Number, required: true },
        quantity: { type: Number, required: true },
        isCanDraw: { type: Boolean, required: true },
    },
    data: function() {
        return {
            itemQuantity: this.value,
            isLimit: false,
        }
    },
    mounted: function() {
        if (this.quantity == 0) {
            this.isLimit = true;
            this.itemQuantity = 0;
        }
        this.checkLimit();
    },
    methods: {
        checkLimit: function () {
            if (this.itemQuantity == this.quantity) this.isLimit = true;
        },
        increaseValue: function () {
            if (this.isLimit || !this.isCanDraw) return
            this.itemQuantity += 1;
            this.checkLimit();
            this.$emit('updateValue', this.itemQuantity);
        },
        decreaseValue: function () {
            if (this.itemQuantity <= 1) return
            this.itemQuantity -= 1;
            if (this.itemQuantity <= this.quantity) this.isLimit = false;
            this.$emit('updateValue', this.itemQuantity);
        }
    }
}
</script>

<style lang="scss" scoped>
    #quantity_flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #58595b;

        .quantity-txt {
            color: #58595b;
            font-size: 20px;
        }
        .btn-quantity {
            border: none;
            background: none;
            padding: 0;
        }
    }
</style>